var _rect, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 41,
    viewBox: "0 0 47 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 0.5,
    width: 40,
    height: 40,
    rx: 9.5,
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 21.5,
    r: 6.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "plus",
    d: "M9.82227 20.7891V22.2725H3V20.7891H9.82227ZM7.21094 18V25.2461H5.61816V18H7.21094Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 12H33C34.1 12 35 12.9 35 14V28C35 29.1 34.1 30 33 30H19C17.89 30 17 29.1 17 28L17.01 14C17.01 12.9 17.89 12 19 12H20V10H22V12H30V10H32V12ZM19 28H33V17H19V28Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/calendar.3e1ba74f963066635a5cb1d889d5ae61.svg";